import { slidesTemplatePack2029 } from './2029/slides/templatePack';

export function getSlidesTemplatePack(deckId) {
  const id = deckId ? String(deckId) : '2029';
  if (id === '2029') return slidesTemplatePack2029;
  return slidesTemplatePack2029;
}
